import React from "react";
import { NavLink } from "react-router-dom";
import Button from "../../components/button/button";

// import "./NavigationItems.css";
import "./contacts.css";

function ContactsContainer(props) {
  return (
    <div id="contacts" className="page">
      <h1>Contact us</h1>
      <hr />
      {props.isAuth && (
        <Button design="raised" mode="accent" onClick={props.onAddContact}>
          New contact
        </Button>
      )}
      <ul id="contact-items">{props.children} </ul>
    </div>
  );
  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default ContactsContainer;
